<header class="wpp-header">
  <div class="container-fluid">
    @if (brandUrl()) {
      <div
        class="wpp-header__brand"
        role="button"
        tabindex="0"
        (click)="brandClicked.emit()"
        (keydown.enter)="brandClicked.emit()"
        (keydown.space)="$event.preventDefault(); brandClicked.emit()"
      >
        <img [src]="brandUrl()" alt="PonCenter" decoding="async" fetchpriority="high" />
      </div>
    }

    @if (brandWordmarkSrc(); as wordmark) {
      <div class="wpp-header__wordmark">
        <img [src]="wordmark" alt="" aria-hidden="true" decoding="async" />
      </div>
    }
  </div>
</header>
